import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { locations, locationsToScreens, screens } from "../constants/constants";
import { AppContentContainer } from "./AppContentContainer";
import { Curtain } from "./Curtain";
import { FullScreenBackdrop } from "./FullScreenBackdrop";
import { Screens } from "./Screens";

const Ioco = () => {
  /* current location from wouter */
  const [location, locationSet] = useLocation();
  /* isCurtainActive visible */
  const [isCurtainActive, isCurtainActiveSet] = useState(false);
  const [isCurtainIntro, isCurtainIntroSet] = useState(false);
  const [isCurtainHorizontal, isCurtainHorizontalSet] = useState(false);
  const [isCurtainToLeft, isCurtainToLeftSet] = useState(false);
  const [curtainTo, curtainToSet] = useState("");
  const [screen, screenSet] = useState(screens.loading);

  /* isCurtainActive start trigger */

  const onCurtainStart = ({
    curtainTo,
    horizontal = false,
    toLeft = false,
  }: {
    curtainTo: string;
    horizontal?: boolean | undefined;
    toLeft?: boolean | undefined;
  }) => {
    isCurtainActiveSet(true);
    isCurtainIntroSet(true);
    isCurtainHorizontalSet(horizontal);
    isCurtainToLeftSet(toLeft);
    curtainToSet(curtainTo);
  };
  const onCurtainHides = () => {
    screenSet(curtainTo);
    isCurtainIntroSet(false);
    locationSet(locations[curtainTo]);
  };
  const onCurtainEnd = () => {
    isCurtainActiveSet(false);
    curtainToSet("");
  };

  // console.log({ isCurtainActive });
  // console.log({ isCurtainIntro });
  // console.log({ curtainTo });
  // console.log({ isCurtainHorizontal });
  // console.log({ isCurtainToLeft });

  /* sync location and screen when not isCurtainActive and not for loading screen */
  useEffect(() => {
    if (!isCurtainActive && screen !== screens.loading) {
      if (screen !== locationsToScreens(location)) {
        screenSet(locationsToScreens(location));
      }
    }
  }, [isCurtainActive, screen, location]);

  return (
    <FullScreenBackdrop>
      <AppContentContainer>
        <Screens
          {...{
            screen,
            isCurtainActive,
            isCurtainIntro,
            onCurtainStart,
          }}
        />

        {isCurtainActive && (
          <Curtain
            {...{
              onCurtainHides,
              onCurtainEnd,
              horizontal: isCurtainHorizontal,
              toLeft: isCurtainToLeft,
            }}
          />
        )}
      </AppContentContainer>
    </FullScreenBackdrop>
  );
};

export default Ioco;
